export default __webpack_public_path__ + "static/media/img-submit.d3c5f410.svg";